import { render } from "./bottomNavigationBar.vue?vue&type=template&id=3a447699&scoped=true"
import script from "./bottomNavigationBar.vue?vue&type=script&lang=js"
export * from "./bottomNavigationBar.vue?vue&type=script&lang=js"

import "./bottomNavigationBar.vue?vue&type=style&index=0&id=3a447699&lang=scss&scoped=true"
import "./bottomNavigationBar.vue?vue&type=style&index=1&id=3a447699&lang=scss"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a447699"]])

export default __exports__